"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var merge_reducers_1 = require("./merge-reducers");
exports.mergeReducersWithStorage = merge_reducers_1.mergeReducersWithStorage;
var defaults_1 = require("./defaults");
exports.getDefaultStorageSettings = defaults_1.getDefaultStorageSettings;
exports.getDefaultReducer = defaults_1.getDefaultReducer;
var meta_information_1 = require("./meta-information");
exports.MetaInformation = meta_information_1.MetaInformation;
exports.listenToLocalStorageChange = meta_information_1.listenToLocalStorageChange;
var storage_1 = require("./storage");
exports.FakeStorage = storage_1.FakeStorage;
exports.loadFromStorage = storage_1.loadFromStorage;
exports.filterByLoadTime = storage_1.filterByLoadTime;
exports.defaultSpecialActionKeyOfOtherTabsActions = storage_1.defaultSpecialActionKeyOfOtherTabsActions;
exports.defaultSpecialItemNameOfOtherTabsActions = storage_1.defaultSpecialItemNameOfOtherTabsActions;
exports.jsonDateParser = storage_1.jsonDateParser;
var tabs_1 = require("./tabs");
exports.handleActionOfOtherTab = tabs_1.handleActionOfOtherTab;
